import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import {
  ServerCrash,
  RefreshCw,
  ArrowLeft,
  Clock3,
  ShieldCheck,
} from "lucide-react";

export default function Error500() {
  return (
    <div className="min-h-screen bg-cream">
      <div className="mx-auto flex min-h-screen max-w-7xl items-center justify-center px-6 py-16 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.35 }}
          className="w-full max-w-2xl rounded-[2rem] border border-ink/10 bg-white p-8 shadow-sm md:p-12"
          data-testid="error500-page"
        >
          <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-peach">
            <ServerCrash
              size={40}
              className="text-hotpink"
              strokeWidth={2.4}
            />
          </div>

          <p className="mt-8 text-center text-xs font-bold uppercase tracking-[0.25em] text-hotpink">
            Internal Server Error
          </p>

          <h1 className="mt-3 text-center font-display text-4xl tracking-tighter md:text-5xl">
            Something went wrong
            <br />
            on our side.
          </h1>

          <p className="mx-auto mt-5 max-w-xl text-center text-ink/65">
            Our servers encountered an unexpected error while processing your
            request. Your account and your data are safe. Please try again in a
            few moments.
          </p>

          <div className="mt-10 rounded-3xl border border-ink/10 bg-cream p-6">
            <p className="text-sm font-semibold text-ink">
              What you can do
            </p>

            <ul className="mt-4 space-y-3 text-sm text-ink/65">
              <li className="flex gap-3">
                <RefreshCw
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Refresh the page after a few seconds.
              </li>

              <li className="flex gap-3">
                <Clock3
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                Wait a minute and try again if the issue continues.
              </li>

              <li className="flex gap-3">
                <ShieldCheck
                  size={16}
                  className="mt-0.5 flex-none text-hotpink"
                />
                If the problem persists, contact support with a screenshot.
              </li>
            </ul>
          </div>

          <div className="mt-10 flex flex-col gap-4 md:flex-row">
            <button
              onClick={() => window.location.reload()}
              data-testid="reload-page-btn"
              className="cta-glow inline-flex flex-1 items-center justify-center gap-2 rounded-full bg-sunset-gradient px-6 py-3 text-sm font-semibold text-white"
            >
              <RefreshCw size={16} />
              Reload Page
            </button>

            <Link
              to="/dashboard"
              data-testid="back-dashboard-btn"
              className="inline-flex flex-1 items-center justify-center gap-2 rounded-full border border-ink/10 bg-white px-6 py-3 text-sm font-semibold text-ink hover:bg-ink/5"
            >
              <ArrowLeft size={16} />
              Dashboard
            </Link>
          </div>

          <div className="mt-8 rounded-2xl bg-mint p-4">
            <p className="font-semibold text-ink">
              Your information is safe
            </p>

            <p className="mt-1 text-sm text-ink/65">
              This error does not affect your Instagram account, customer data,
              payment information, or subscription.
            </p>
          </div>

          <p className="mt-8 text-center text-xs text-ink/50">
            Error Code: 500 • Internal Server Error
          </p>
        </motion.div>
      </div>
    </div>
  );
}